import { render, staticRenderFns } from "./suYanLeiXing.vue?vue&type=template&id=49b6d5d2"
import script from "./suYanLeiXing.vue?vue&type=script&lang=js"
export * from "./suYanLeiXing.vue?vue&type=script&lang=js"
import style0 from "./suYanLeiXing.vue?vue&type=style&index=0&id=49b6d5d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports